<template>
  <div class="animated fadeIn bgV2">
    <b-row>
      <b-col md="12">
        <gofix-tab
            class="mt-3 ContractCaseSettings"
            :data="contract_tab"
            :query-param="{id:$route.params.id}"
            activeKey="operating-hours"
            arrows >
          <template slot="gofixTab:operating-hours">
            <div class="equipment row-split">
              <b-row class="h-100">
                <b-col md="3">
                  <gofix-card title="Type" class="contractTree" fullContent>
                    <template slot="gofixCard:right_header">
                      <b-button class="mr-2" title="Delete" v-b-tooltip.hover @click="modals.deleteType.open = true">
                        <svg width="20" height="20" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                          <path fill="#999999" d="m256 512c-68.378906 0-132.667969-26.628906-181.019531-74.980469-48.351563-48.351562-74.980469-112.640625-74.980469-181.019531s26.628906-132.667969 74.980469-181.019531c48.351562-48.351563 112.640625-74.980469 181.019531-74.980469s132.667969 26.628906 181.019531 74.980469c48.351563 48.351562 74.980469 112.640625 74.980469 181.019531s-26.628906 132.667969-74.980469 181.019531c-48.351562 48.351563-112.640625 74.980469-181.019531 74.980469zm0-472c-119.101562 0-216 96.898438-216 216s96.898438 216 216 216 216-96.898438 216-216-96.898438-216-216-216zm110 195.980469h-220v40h220zm0 0"/>
                        </svg>
                      </b-button>
                      <b-button class="mr-2" title="Create" v-b-tooltip.hover @click="openEditTypeModal(null)">
                        <svg width="20" height="20" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 304.223 304.223" xml:space="preserve">
                          <path fill="#999999" d="M152.112,0C68.241,0,0.008,68.244,0.008,152.114c0,83.865,68.233,152.109,152.103,152.109 c83.865,0,152.103-68.244,152.103-152.109C304.215,68.244,235.977,0,152.112,0z M152.112,275.989c-68.32,0-123.891-55.565-123.891-123.875c0-68.326,55.571-123.891,123.891-123.891s123.891,55.565,123.891,123.891C276.003,220.424,220.426,275.989,152.112,275.989z"/>
                          <path fill="#999999" d="M221.922,139.186h-56.887V82.298c0-7.141-5.782-12.929-12.923-12.929c-7.141,0-12.929,5.782-12.929,12.929v56.887H82.296c-7.141,0-12.923,5.782-12.923,12.929c0,7.141,5.782,12.923,12.923,12.923h56.882v56.893c0,7.142,5.787,12.923,12.929,12.923c7.141,0,12.929-5.782,12.929-12.923v-56.893h56.882c7.142,0,12.929-5.782,12.929-12.923C234.851,144.967,229.063,139.186,221.922,139.186z"/>
                      </svg>
                      </b-button>
                    </template>
                    <div class="opening-hours-type">
                      <ul>
                        <li v-for="item in operatingHourTypes.items" :class="{'active': item.id === operatingHourTypes.active}" @click="selectType(item)">
                          <span class="d-block">{{item.name}}</span>
                          <div class="rightPosition">
                                  <span class="p-0 cursor-pointer" @click="openEditTypeModal(item)">
                                      <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path fill-rule="evenodd" clip-rule="evenodd" d="M17.71 3.63053C18.1 4.02053 18.1 4.65053 17.71 5.04053L15.88 6.87053L12.13 3.12053L13.96 1.29053C14.1468 1.10328 14.4005 0.998047 14.665 0.998047C14.9295 0.998047 15.1832 1.10328 15.37 1.29053L17.71 3.63053ZM0 18.5005V15.4605C0 15.3205 0.05 15.2005 0.15 15.1005L11.06 4.19053L14.81 7.94053L3.89 18.8505C3.8 18.9505 3.67 19.0005 3.54 19.0005H0.5C0.22 19.0005 0 18.7805 0 18.5005Z" fill="#999999"/>
                                      </svg>
                                  </span>
                          </div>
                        </li>
                      </ul>
                    </div>
                  </gofix-card>
                </b-col>
                <b-col md="9" class="h-100 pl-md-0">
                  <gofix-card :title="operatingHourTypes.can_delete?'':' '" class="contractCardFullHeight mb-0" fullContent  v-bind:class="{'run-loading':loading}">
                    <template slot="gofixCard:right_header" v-if="!operatingHourTypes.can_delete">
                      <div class="d-flex justify-content-end align-items-center">
                        <gofix-button label="Save" @click="autoSave" :loading="loading"></gofix-button>
                      </div>
                    </template>
                    <div class="opening-hours-management" v-if="!operatingHourTypes.can_delete">
                      <ul>
                        <li class="item" v-for="item in tableItems">
                          <b-row align-v="center">
                            <b-col md="3"><span class="item-title">{{item.title}}</span></b-col>
                            <b-col md="2">
                              <div class="status">
                                <b-form-checkbox v-model="item.status" value="Open" unchecked-value="Close" switch>
                                </b-form-checkbox>
                              </div>
                            </b-col>
                            <b-col md="2" v-if="item.status == 'Open'">
                              <gofix-form-input-time label="From Time" v-model="item.from_time"></gofix-form-input-time>
                            </b-col>
                            <b-col md="2" v-if="item.status == 'Open'">
                              <gofix-form-input-time label="To Time" v-model="item.to_time"></gofix-form-input-time>
                            </b-col>
                          </b-row>
                        </li>
                      </ul>
                    </div>
                    <gofix-default-table  v-if="operatingHourTypes.can_delete"
                                          :settings="tableConfig"
                                          :table-items="tableItems"
                                          @load-items="getTableData"
                                          @new-item="openCreateModal"
                                          @row-click="openEditModal"
                                          @delete-items="deleteItems"
                                          ref="gofixTable">
                      <template slot="gofix_table:start_time" slot-scope="row">
                        {{row.item.start_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                      </template>
                      <template slot="gofix_table:end_time" slot-scope="row">
                        {{row.item.end_time | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                      </template>
                      <template slot="gofix_table:freq" slot-scope="row">
                        {{modals.newTime.freqs[row.item.freq].label}}
                      </template>
                      <template slot="gofix_table:count" slot-scope="row">
                        {{row.item.count === 1 ? 'No':'Yes'}}
                      </template>

                      <template slot="gofix_table:byweekday" slot-scope="row">
                        {{row.item.byweekday | formatByWeekDay}}
                      </template>
                      <template slot="gofix_table:bymonth" slot-scope="row">
                        {{row.item.bymonth | formatByMonth}}
                      </template>


                    </gofix-default-table>
                  </gofix-card>
                </b-col>
              </b-row>
            </div>
          </template>
        </gofix-tab>
      </b-col>
    </b-row>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.newTime.title" hide-footer :centered="true" v-model="modals.newTime.open">
      <b-form class="">
        <b-row>
          <b-col md="12">
            <gofix-form-input label="Title" v-model="modals.newTime.data.title" required></gofix-form-input>
          </b-col>
          <b-col md="7">
            <gofix-form-input-date
                v-model="modals.newTime.data.from_date"
                required
                label="From date" />
          </b-col>
          <b-col md="5">
            <gofix-form-input-time label="From Time" v-model="modals.newTime.data.from_time"></gofix-form-input-time>
          </b-col>
          <b-col md="7">
            <gofix-form-input-date
                v-model="modals.newTime.data.to_date"
                label="End date" />
          </b-col>
          <b-col md="5">
            <gofix-form-input-time label="End Time" v-model="modals.newTime.data.to_time"></gofix-form-input-time>
          </b-col>
          <b-col md="6">
            <gofix-form-dropdown label="Frequency"
                                 required
                                 v-model="modals.newTime.data.freq"
                                 :reduce="option => option.value"
                                 :options="modals.newTime.freqs">
            </gofix-form-dropdown>
          </b-col>
          <b-col md="6">
            <gofix-form-input-number label="Interval"
                                     v-model="modals.newTime.data.interval"
                                     required
                                     :integer-limit="15"
                                     :include-thousands-separator="false"
                                     :allowDecimal="false"></gofix-form-input-number>
          </b-col>
          <b-col md="6">
            <gofix-form-dropdown label="Status"
                                 v-model="modals.newTime.data.status"
                                 :clearable="false"
                                 :options="['Open','Close']">
            </gofix-form-dropdown>
          </b-col>
          <b-col md="6">
            <gofix-form-dropdown label="Repeat"
                                 v-model="modals.newTime.data.count"
                                 :clearable="false"
                                 :reduce="option => option.value"
                                 :options="modals.newTime.repeat">
            </gofix-form-dropdown>
          </b-col>
          <b-col md="12" class="mb-3" v-if="!modals.newTime.data.count">
            <h3 class="title font-size-16">By week day</h3>
            <b-col md="12">
              <b-row>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="0"><span class="ml-2">Monday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="1"><span class="ml-2">Tuesday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="2"><span class="ml-2">Wednesday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="3"><span class="ml-2">Thursday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="4"><span class="ml-2">Friday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="5"><span class="ml-2">Saturday</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.byweekday" value="6"><span class="ml-2">Sunday</span></b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
          <b-col md="12" v-if="!modals.newTime.data.count">
            <h3 class="title font-size-16">By month</h3>
            <b-col md="12">
              <b-row>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="1"><span class="ml-2">January</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="2"><span class="ml-2">February</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="3"><span class="ml-2">March</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="4"><span class="ml-2">April</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="5"><span class="ml-2">May</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="6"><span class="ml-2">June</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="7"><span class="ml-2">July</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="8"><span class="ml-2">August</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="9"><span class="ml-2">September</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="10"><span class="ml-2">October</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="11"><span class="ml-2">November</span></b-form-checkbox>
                </b-col>
                <b-col md="3">
                  <b-form-checkbox v-model="modals.newTime.data.bymonth" value="12"><span class="ml-2">December</span></b-form-checkbox>
                </b-col>
              </b-row>
            </b-col>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right" >
        <gofix-button label="SUBMIT" :loading="modals.newTime.loading" noBorder @click="save"></gofix-button>
      </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.newType.title" hide-footer :centered="true" v-model="modals.newType.open">
      <b-form class="">
        <b-row>
          <b-col md="12">
            <gofix-form-input label="Name" v-model="modals.newType.data.name"></gofix-form-input>
          </b-col>
        </b-row>
      </b-form>
      <b-button-group class="d-block text-right" >
        <gofix-button :label="modals.newType.data.id ? 'SAVE' : 'CREATE'" :loading="modals.newType.loading" noBorder @click="saveType"></gofix-button>
      </b-button-group>
    </b-modal>
    <b-modal :no-close-on-backdrop="true" id="modal-Remove" title="Remove operating hour type" hide-footer hide-header :centered="true" v-model="modals.deleteType.open">
      <div class="center">Are you sure you want to delete the type?</div>
      <b-button-group class="btn-group">
        <b-button class="custom-btn" @click="modals.deleteType.open = false">No</b-button>
        <b-button class="custom-btn" @click="deleteType" :disabled="modals.deleteType.loading">
          <b-spinner v-if="modals.deleteType.loading" small type="grow"></b-spinner>Yes
        </b-button>
      </b-button-group>
    </b-modal>
  </div>
</template>
<script>
import tabData from '@/data/_tabs';
import { mapGetters } from 'vuex';
import moment from 'moment';
import { filters } from '@/_filterVar.js'
export default {
  name: 'contract-operating-hours',
  data () {
    let filter = JSON.parse(JSON.stringify(filters['operating_hours']));
    return {
      contract_tab: tabData.client_contract,
      tableItems: [],
      tableConfig:{
        name: 'operating-hours',
        controls:{

        },
        filter: filter,
        page: 1,
        limit: 100,
        sortColumn: "id",
        sortDirection: "desc",
      },
      modals:{
        newTime:{
          title: 'Create new',
          loading: false,
          open: false,
          data: {
            title: '',
            status:'Open',
            type_id:null,
            start_time:null,
            end_time:null,
            from_date:null,
            from_time:null,
            to_date:null,
            to_time:null,
            freq:null,
            count:1,
            interval:1,
            byweekday: [],
            bymonth: [],
          },
          freqs:[
            {
              "label" : "YEARLY",
              "value" : 0
            },
            {
              "label" : "MONTHLY",
              "value" : 1
            },
            {
              "label" : "WEEKLY",
              "value" : 2
            },
            {
              "label" : "DAILY",
              "value" : 3
            },
            {
              "label" : "HOURLY",
              "value" : 4
            },
            {
              "label" : "MINUTELY",
              "value" : 5
            },
            {
              "label" : "SECONDLY",
              "value" : 6
            }
          ],
          repeat:[
            {
              "label" : "Yes",
              "value" : 0
            },
            {
              "label" : "No",
              "value" : 1
            },
          ],
        },
        newType:{
          title: 'Create new',
          loading: false,
          open: false,
          data: {
            id: null,
            name: '',
            contract_id: this.$route.params.id
          },
        },
        deleteType:{
          loading:false,
          open:false,
        }
      },
      operatingHourTypes:{
        items:[],
        active: null,
        can_delete: true
      },
      loading:false
    }
  },
  components: {
  },
  created() {
    this.getOperatingHourType();
  },
  filters: {
    formatByWeekDay(value) {
      if (!value || !value.length) return ;
      let data = ['Monday','Tuesday','Wednesday','Thursday','Friday','Saturday','Sunday']
      let reponse = []
      for (let i = 0;i < value.length; i++){
        reponse.push(data[value[i]])
      }
      return reponse.join(', ')
    },
    formatByMonth(value) {
      if (!value || !value.length) return ;
      let data = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
      let reponse = []
      for (let i = 0;i < value.length; i++){
        reponse.push(data[value[i]])
      }
      return reponse.join(', ')
    },
  },
  watch: {
    "operatingHourTypes.active" : function(val){
      if(val){
        this.$refs.gofixTable.reloadTableItems();
      }
    }
  },
  computed: {
    ...mapGetters({
    })
  },
  methods: {
    getOperatingHourType(){
      this.$store.dispatch(`OperatingHourTypeController/getItems`, {limit:-1,filter:{contract_id:this.$route.params.id}})
          .then(response => {
            this.operatingHourTypes.items = response.items;
            if(this.operatingHourTypes.active == null && this.operatingHourTypes.items.length){
              this.operatingHourTypes.can_delete = this.operatingHourTypes.items[0].can_delete
              this.operatingHourTypes.active = this.operatingHourTypes.items[0].id
            }
          })
    },
    saveType(){
      if(!this.modals.newType.data.name){
        return this.$alertNotification("Please enter the Name", "danger");
      }
      if(this.modals.newType.loading) return;
      this.modals.newType.loading = true;
      if(!this.modals.newType.data.id){
        this.$store.dispatch("OperatingHourTypeController/saveItem", this.modals.newType.data)
            .then(response => {
              this.getOperatingHourType();
              this.modals.newType.loading = false;
              this.modals.newType.open = false;
              this.$alertNotification(this.$notificationV2('adding', 'operating_hour_type'));
            })
            .catch(err => {
              this.modals.newType.loading = false;
            });
      }else{
        this.$store.dispatch("OperatingHourTypeController/updateItem", this.modals.newType.data)
            .then(response => {
              this.getOperatingHourType();
              this.modals.newType.loading = false;
              this.modals.newType.open = false;
              this.$alertNotification(this.$notificationV2('editing', 'operating_hour_type'));
            })
            .catch(err => {
              this.modals.newType.loading = false;
            });
      }
    },
    deleteType(){
      if(!this.operatingHourTypes.active){
        this.modals.deleteType.open = false
        return this.$alertNotification("Please select a type to delete", "danger");
      }
      if(this.modals.deleteType.loading) return ;
      this.modals.deleteType.loading = true;
      this.$store.dispatch("OperatingHourTypeController/deleteItems", [this.operatingHourTypes.active])
          .then(response => {
            this.modals.deleteType.open = false
            this.modals.deleteType.loading = false
            this.operatingHourTypes.active = null
            this.getOperatingHourType();
            this.$alertNotification(this.$notificationV2('deleting', 'operating_hour_type'));
          })
          .catch(err => {
            this.modals.deleteType.open = false
            this.modals.deleteType.loading = false
          });

    },
    selectType(item){
      this.operatingHourTypes.active = item.id
      this.operatingHourTypes.can_delete = item.can_delete
    },
    async getTableData(callback){
      const { tableRequest , resolve,reject } = await callback();
      if(!this.operatingHourTypes.active){
        resolve({items:[],total:0})
        return;
      }
      if(!this.operatingHourTypes.can_delete){
        tableRequest.sortColumn = "id"
        tableRequest.sortDirection = "asc"
      }
      tableRequest.filter.type_id.value = this.operatingHourTypes.active;
      this.loading = true
      await this.$store.dispatch("OperatingHourController/getItems", tableRequest)
          .then(response => {
            this.tableItems = response.items;
            this.tableConfig.total = response.total;
            this.loading = false
            resolve(response);
          })
          .catch(err => {
            this.$alertNotification("Can not load the data", "danger");
            this.loading = false
            reject();
          })
    },
    save(){
      if(!this.modals.newTime.data.title){
        return this.$alertNotification("Please enter the title", "danger");
      }
      if(!this.modals.newTime.data.status){
        return this.$alertNotification("Please select a status", "danger");
      }
      if(!this.modals.newTime.data.from_date){
        return this.$alertNotification("Please select a from date", "danger");
      }
      if(!this.modals.newTime.data.freq == null){
        return this.$alertNotification("Please enter the frequency", "danger");
      }
      if(!this.modals.newTime.data.interval){
        return this.$alertNotification("Please enter the interval", "danger");
      }
      if(this.modals.newTime.loading) return;
      this.modals.newTime.loading = true;
      let from_date = moment(this.modals.newTime.data.from_date).format('YYYY-MM-DD')
      let from_time = this.modals.newTime.data.from_time ? this.modals.newTime.data.from_time : '00:00'
      let to_date = moment(this.modals.newTime.data.to_date).format('YYYY-MM-DD')
      let to_time = this.modals.newTime.data.to_time ? this.modals.newTime.data.to_time : '23:59'
      this.modals.newTime.data.start_time = from_date + ' ' + from_time;
      this.modals.newTime.data.end_time = (this.modals.newTime.data.to_date && to_time) ? (to_date + ' ' + to_time) : null

      //Check time
      if(this.modals.newTime.data.end_time){
        let beginningTime = moment(this.modals.newTime.data.start_time, 'YYYY-MM-DD hh:mm')
        let endTime = moment(this.modals.newTime.data.end_time, 'YYYY-MM-DD hh:mm')
        if(!beginningTime.isBefore(endTime)){
          this.modals.newTime.loading = false;
          return this.$alertNotification("Invalid time. End date must be greater than start date", "danger");
        }
      }

      this.modals.newTime.data.type_id = this.operatingHourTypes.active
      this.modals.newTime.data.byweekday = this.modals.newTime.data.count == 1 ? null : this.modals.newTime.data.byweekday
      this.modals.newTime.data.bymonth = this.modals.newTime.data.count == 1 ? null : this.modals.newTime.data.bymonth
      if(!this.modals.newTime.data.id){
        this.$store.dispatch("OperatingHourController/saveItem", this.modals.newTime.data)
            .then(response => {
              this.$refs.gofixTable.reloadTableItems();
              this.modals.newTime.loading = false;
              this.modals.newTime.open = false;
              this.$alertNotification(this.$notificationV2('adding', 'operating_hour'));
            })
            .catch(err => {
              this.modals.newTime.loading = false;
              this.modals.newTime.open = false;
            });
      }else{
        this.$store.dispatch("OperatingHourController/updateItem", this.modals.newTime.data)
            .then(response => {
              this.$refs.gofixTable.reloadTableItems();
              this.modals.newTime.loading = false;
              this.modals.newTime.open = false;
              this.$alertNotification(this.$notificationV2('editing', 'operating_hour'));
            })
            .catch(err => {
              this.modals.newTime.loading = false;
              this.modals.newTime.open = false;
            });
      }
    },
    async autoSave(){
      if(this.loading) return;
      this.loading = true;
      for (let i = 0; i < this.tableItems.length; i++){
        let item = this.tableItems[i]
        if (item.status === 'Open'){
          item.from_time = item.from_time ?  item.from_time : '00:00'
          item.to_time = item.to_time ?  item.to_time : '23:59'
          //Check time
          let beginningTime = moment(item.from_time, 'hh:mm')
          let endTime = moment(item.to_time, 'hh:mm')
          if(!beginningTime.isBefore(endTime)){
            this.loading = false;
            return this.$alertNotification("Invalid time ("+item.title+")", "danger");
          }
        }else{
          item.from_time = null
          item.to_time = null
        }
        await this.$store.dispatch("OperatingHourController/updateItem", item)
      }
      this.loading = false;

    },
    async deleteItems(callback){
      const { ids,filter, resolve,reject } = await callback();
      await this.$store.dispatch('OperatingHourController/deleteItems', ids)
          .then(response => {
            resolve(this.$notificationV2('deleting', 'operating_hour'));
          })
          .catch(err => {
            reject();
          })
    },
    openEditTypeModal(item){
      this.modals.newType.title = item ? 'Edit operating hour type' : 'Create new'
      this.modals.newType.data.id = item ? item.id : null
      this.modals.newType.data.name = item ? item.name : null
      this.modals.newType.data.contract_id = item ? item.contract_id : this.$route.params.id
      this.modals.newType.open = true
    },
    openCreateModal(){
      this.modals.newTime.title = 'Add time'
      this.modals.newTime.open = true
      this.modals.newTime.data = {
        id: null,
        title: null,
        status: 'Open',
        type_id:this.operatingHourTypes.active,
        start_time:null,
        end_time:null,
        from_date:null,
        from_time:null,
        to_date:null,
        to_time:null,
        freq:0,
        count:0,
        interval:1,
        byweekday:[],
        bymonth: [],
      };
    },
    openEditModal(item){
      this.modals.newTime.title = 'Edit time'
      this.modals.newTime.open = true
      let from_date = new Date(item.start_time)
      let from_time = moment(item.start_time,"YYYY-MM-DD HH:mm").format("HH:mm")
      let to_date = null
      let to_time = null
      if(item.end_time){
        to_date = new Date(item.end_time)
        to_time = moment(item.end_time,"YYYY-MM-DD HH:mm").format("HH:mm")
      }
      this.modals.newTime.data = {
        id: item.id,
        title: item.title,
        status: item.status,
        type_id:item.type_id,
        start_time:item.start_time,
        end_time:item.end_time,
        from_date:from_date,
        from_time:from_time,
        to_date:to_date,
        to_time:to_time,
        freq:item.freq,
        count:item.count,
        interval:item.interval,
        byweekday:item.byweekday,
        bymonth: item.bymonth,
      };
    }
  },
}
</script>
